<template>
    <div>
        <quill-editor ref="myTextEditor" id="myTextEditor"
                      v-model="value" :options="quillOption">
        </quill-editor>

        <div  id="el-math"  style="display: none">
            <div class="el-dialog__wrapper" style="z-index: 2005">
                <div role="dialog"  class="el-dialog"
                     style="margin-top: 15vh; width: 500px;">
                    <div class="el-dialog__header"><span class="el-dialog__title">公式编辑器</span>
                        <button  @click="handleCancel()" type="button" aria-label="Close" class="el-dialog__headerbtn"><i
                                class="el-dialog__close el-icon el-icon-close"></i></button>
                    </div>
                    <div class="el-dialog__body">
                        <el-button @click="handleFormat('\\dfrac')"><span v-katex="'\\cfrac{a}{b}'" ></span></el-button>
                        <el-button @click="handleFormat('\\sqrt')"><span v-katex="'\\sqrt{a}'"  ></span></el-button>


                        <p>Type math: <span id="math-field"></span></p>
                        <p>LaTeX : <span id="latex"></span></p>
                    </div>
                    <div class="el-dialog__footer"><span class="dialog-footer">
                        <button type="button" class="el-button el-button--default" @click="handleCancel()"><span>取 消</span></button>
                        <button type="button" class="el-button el-button--primary" @click="handleActive()" ><span >确 定</span></button></span></div>
                </div>
            </div>

            <div class="v-modal" tabindex="0" style="z-index: 2003;"></div>
        </div>
    </div>

</template>

<script>
    import './math.js'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import { quillEditor} from 'vue-quill-editor'
    import quillConfig from './quill-config.js'


    export default {
        components: {
            quillEditor
        },
        mounted(){
            quillConfig.initButton();
            let mathFieldSpan = document.getElementById('math-field');
            let latexSpan = document.getElementById('latex');
            let MQ = MathQuill.getInterface(2);
            let mathField = MQ.MathField(mathFieldSpan, {
                spaceBehavesLikeTab: true, // configurable
                handlers: {
                    substituteTextarea: function() {
                        return document.createElement('textarea');
                    },
                    edit: function () { // useful event handlers
                        latexSpan.textContent = mathField.latex(); // simple API
                    }
                }
            });
            this.mathField=mathField
        },
        data() {
            return {
                mathArea:"",
                // content: '<p>freddy</p>',
                quillOption: quillConfig,
                mathField:""
            }
        },
        props: ["value"],
        computed: {
            editor() {
                return this.$refs.myTextEditor.quill
            }
        },
        methods:{
            handleFormat(value){
                this.mathField.focus()
                this.mathField.typedText(value)
                this.mathField.keystroke('Spacebar')
            },
            handleCancel(){
                document.getElementById('el-math').style.display="none";
            },
            handleActive(){
                let length = this.$refs.myTextEditor.quill.selection.savedRange.index
                this.editor.insertEmbed(length?length:1, 'math', document.getElementById('latex').innerText)
                this.editor.setSelection(length + 1)
            }
        }
    }
</script>
